





































import Proxyable from '@/mixins/proxyable';
import mixins from '@/utils/mixins';
import { ModuleViewType } from '@/models/configurator/module';

export default mixins(Proxyable).extend({
  name: 'ModuleViewSelector',

  data() {
    return {
      ModuleViewType
    };
  }
});
